<section class="hero">
  <div class="wrapper">
    <h1 appGsapHeroIntro class="text-center assets-hero-title section-spacing">
      What is Incident Management? <span>Guide for IT Teams</span>
    </h1>

    <p>
      Incident management refers to the IT process of identifying, recording, categorising, fixing,
      and closing out unexpected service disruptions - bringing systems back to normal operation as
      quickly as possible while keeping the impact on the business to a minimum.
    </p>

    <div class="hero-img flex justify-center">
      <div class="dashboard-wrapper">
        <img
          src="/assets/img/feature-imgs/itsm/incident-dashboard.png"
          fetchpriority="high"
          alt="dashboardITSM dashboard showing ticket analytics and SLA tracking"
          width="991"
          height="567.29"
        />
      </div>
    </div>
  </div>
</section>

<app-content-layout [config]="config" [accentColor]="accentColor" />

<app-modern-cta
  heading="Ready to Implement ITSM?
Explore Infraon's ITSM Tool"
  secondaryLabel="Start Your Free Trial"
  secondaryLink="/registration"
  [secondaryQueryParams]="{ type: 'trial', product: 'Infraon ITSM' }"
  [tags]="[
    'No credit card details required',
    'Custom walkthrough for your use case',
    'Live savings calculator',
  ]"
  bottomGlow="rgba(255, 147, 44, 0.12)"
/>
